export default __webpack_public_path__ + "static/media/02n.568d00cf.svg";